import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import './index.css';
import App from './App';
import config from './config';

// Configure API Base URL
axios.defaults.baseURL = config.API_URL;

axios.interceptors.response.use(
  (response) => {
    const body = response.data;
    if (
      body
      && typeof body === 'object'
      && !Array.isArray(body)
      && Object.prototype.hasOwnProperty.call(body, 'Success')
      && Object.prototype.hasOwnProperty.call(body, 'data')
    ) {
      response.apiMessage = body.message;
      response.apiSuccess = body.Success;
      response.data = body.data;
    }
    return response;
  },
  (error) => {
    const body = error.response?.data;
    if (
      body
      && typeof body === 'object'
      && !Array.isArray(body)
      && Object.prototype.hasOwnProperty.call(body, 'Success')
    ) {
      error.apiMessage = body.message;
      error.response.data = body.error || { message: body.message };
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
